import AppBar from '@mui/material/AppBar'
import React from 'react'
import Grid from '@mui/material/Grid'
import { SettingsSubheader } from '../../shared/organism/SettingsSubheader'
import { Typography } from '@mui/material'
import { fonts } from '../../../theme/theme'


export const BrokerSettingsHeader = () => {
  const profileName = 'Priwall Inc'
  const pathName = 'broker-settings'

  return (
    <AppBar
      position={'relative'}
      color={'transparent'}
      elevation={0}
      sx={{
        maxWidth: 'xl',
        justifySelf: 'center',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexDirection: 'row',
        mx: 'auto',
        px: 5,
        mt: '28px',
      }}>
      <Grid container rowSpacing={10}>
        <Grid item xs={12} sm>
          <Typography variant={'h1'} sx={{ fontFamily: fonts.Jakarta.Bold }}>
            {profileName}
          </Typography>
        </Grid>
        <Grid item xs></Grid>
        <Grid item xs={12}>
          <SettingsSubheader pathName={pathName} />
        </Grid>
      </Grid>
    </AppBar>
  )
}
